import { FunctionComponent } from 'react';
import { Badge } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { StageType } from '@/model';

type StageTypeBadgeProps = {
  type: StageType;
};

const COLOR_SCHEME: Record<StageType, string> = {
  [StageType.LEAGUE]: 'green',
  [StageType.GROUP]: 'purple',
  [StageType.KNOCKOUT]: 'orange',
};

const LABEL_KEY: Record<StageType, string> = {
  [StageType.LEAGUE]: 'league',
  [StageType.GROUP]: 'group',
  [StageType.KNOCKOUT]: 'knockout',
};

export const StageTypeBadge: FunctionComponent<StageTypeBadgeProps> = ({ type }) => {
  const { t } = useTranslation();

  return (
    <Badge
      colorScheme={COLOR_SCHEME[type]}
      borderRadius="full"
      px={2}
      py="2px"
      textTransform="none"
      fontWeight="medium"
    >
      {t(`pages.application_season.components.stage_type.${LABEL_KEY[type]}`)}
    </Badge>
  );
};
